import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

Sentry.init({
  dsn: 'https://5203d9757e6960d91ea7b0e00172c910@o431787.ingest.us.sentry.io/4510772427423744',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
